export const deleteBrewMenuDisplayMutation = /* GraphQL */ `mutation DeleteBrewMenuDisplay($input: inputDeleteBrewMenuDisplay!) {
    deleteBrewMenuDisplay(input: $input) {
        id
    }}`
